export enum ClientRouteParamType {
  Locale = 'locale',
  WorkspaceName = 'workspaceName',
  DatabaseId = 'databaseId',
  DatabaseViewId = 'databaseViewId',
  DatabaseItemId = 'databaseItemId',
  ConversationId = 'conversationId',
  DashboardId = 'dashboardId',
  AutomationId = 'automationId',
  CallId = 'callId',
  CallRoomId = 'callRoomId',
  FolderId = 'folderId',
  DirectConversationId = 'directConversationId',
  DocumentId = 'documentId',
  WhiteboardId = 'whiteboardId',
  SkillId = 'skillId',
  AgentId = 'agentId',
  CollectionItemId = 'collectionItemId',
  ResourceCollection = 'resourceCollection',
}
